/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invitesubexpiredbtninvite4Inputs */



/**
* | output |
* | --- |
* | "Invite friends" |
*
* @param {Invitesubexpiredbtninvite4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const invitesubexpiredbtninvite4 = /** @type {((inputs?: Invitesubexpiredbtninvite4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invitesubexpiredbtninvite4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Invite friends")
	if (locale === "es") return /** @type {LocalizedString} */ ("Invitar amigos")
	return /** @type {LocalizedString} */ ("Позвать друзей")
});
export { invitesubexpiredbtninvite4 as "inviteSubExpiredBtnInvite" }